import { generateServiceId } from "@core/domains/identity";

export const MEDIA_SERVICE = {
  ID: generateServiceId("media"),
  JOB_TYPES: {
    previewBackfill: "previewBackfill",
    previewGeneration: "previewGeneration",
  },
  LABEL: "media",
} as const;
